<template>
    <div>
        <h1 class="title">Impressum</h1>
        Eva Doleisch von Dolsperg<br/>
        Steuerberaterin<br/>
        Engelbosteler Damm 7<br/>
        30167 Hannover<br/><br/>
        Tel. 05 11 / 16 95 16 95<br/>
        Fax 05 11 / 16 95 16 99<br/><br/>
        E-Mail <a href="mailto:eva@r-doleisch.de">info@eva-doleisch.de</a>
        <br/><br/>
        Die Berufsbezeichnung Steuerberaterin ist in Deutschland verliehen worden.<br>
        Gerichtsstand ist Hannover.
        <br/><br/>
        <h2 class="subtitle">Zuständige Aufsichtsbehörde</h2>
        Steuerberaterkammer Niedersachsen<br/>
        Adenauerallee 20<br/> 30175 Hannover<br/><br/>
        Tel. 0511-288 90-0<br/>
        Fax 0511-283 40 32<br/>
        <a href="http://www.stbk-niedersachsen.de">www.stbk-niedersachsen.de</a><br/><br/>

        <h2 class="subtitle">Berufsrechtliche Regeln</h2>
        StBerG, DVStB, BOStB, StBVV<br/>
        <a href="http://www.dstv.de/fuer-die-praxis/rechtsgrundlagen-im-beruf">www.dstv.de/fuer-die-praxis/rechtsgrundlagen-im-beruf</a><br/><br/>

        <h2 class="subtitle">Berufshaftpflichtversicherung</h2>
        Allianz Versicherungs-AG<br/>10900 Berlin<br/>
        Tel. 0 08 00.11 22 33 44 oder +49.89.38 00 23 00<br/>
        Fax 0800 44 00 102<br/>
        Sie genügt den Anforderungen des § 67 StBerG.<br/>
        Geltungsbereich ist Deutschland.
        <br/><br/>
        <h2 class="subtitle">Haftungshinweis</h2>
        <p>Für die Aktualität sowie Richtigkeit und Vollständigkeit dieser Seite und verlinkter Seiten wird keine Gewähr übernommen.</p>
        <br/>
        <h2 class="subtitle">Datenschutz</h2>
        <p><a href="download/Datenschutzerklärung_Doleisch.pdf" target="_blank" rel="noopener noreferrer">Datenschutzerklärung &nbsp;<span class="tag">PDF</span></a> </p>
    </div>
</template>

<script>
    export default {
        data() {
            return {}
        }
    }
</script>